import StackedBar from 'components/atoms/GraphStackedbar';
import { EMPTY_JUSTIFICATION_CHART } from 'constants/planning/chart-justification';
import React from 'react';
import config from './config';
import { IDataGaphic, IGraphicProps } from './types';

function compareData(a: IDataGaphic, b: IDataGaphic) {
  return a.total - b.total;
}

const ChartJustification = ({ data, sorting }: IGraphicProps) => {
  const dataChart = React.useMemo<IDataGaphic[]>(() => {
    if (sorting) {
      // by default, DESC
      data?.sort(compareData);

      // IF asc = just reverse desc
      if (sorting === 'ASC') {
        data?.reverse();
      }
    }

    return data || EMPTY_JUSTIFICATION_CHART;
  }, [data, sorting]);

  return (
    <StackedBar
      height={250}
      width={300}
      data={dataChart}
      config={config}
      hasData={dataChart !== EMPTY_JUSTIFICATION_CHART}
    />
  );
};

export default ChartJustification;
